import { resolve } from 'url';
import EventService from '../../../helpers/classes/EventService';
import { ExceptionManager } from '../../../helpers/classes/ExceptionManager';
import HttpService from '../../../helpers/classes/HttpService';
import RenderingService, { ISelectItem } from '../../../helpers/classes/RenderingService';
import TemplateService from '../../../helpers/classes/TemplateService';
import { JourneyContainer } from '../../classes/JourneyContainer';
import { HighLevelResult } from '../../enums/HighLevelResult';
import { JourneyEvent } from '../../enums/JourneyEvent';
import { Templates } from '../../enums/Templates';
import { TranslationKey } from '../../enums/Translation';
import { ENDPOINTS } from '../../configuration/Endpoints';

export class TermsAndConditionsStep {

	public static render(this: JourneyContainer) {
		return TemplateService.renderToContainer(this._container, Templates.TermsAndConditions)
			.then((element) => TemplateService.getElements(element, {
				termsAndConditionsModal: '[data-jcs-element="terms__and__conditions__container"]',
				termsAndConditionsTickBox1: '[data-jcs-element="terms__and__conditions__tickbox1"]',
				termsAndConditionsTickBox1Text: '[data-jcs-element="terms__and__conditions__tickbox1text"]',
				termsAndConditionsTickBox2: '[data-jcs-element="terms__and__conditions__tickbox2"]',
				termsAndConditionsTickBox2Text: '[data-jcs-element="terms__and__conditions__tickbox2text"]',
				termsAndConditionsModalAgree: '[data-jcs-element="terms__and__conditions__modal__agree"',
				termsAndConditionsModalDisagree: '[data-jcs-element="terms__and__conditions__modal__disagree"',
				termsAndConditionsModalText: '[data-jcs-element="terms__and__conditions__text"]'
			}))
			.then(({ termsAndConditionsModal, termsAndConditionsTickBox1, termsAndConditionsTickBox1Text, termsAndConditionsTickBox2, termsAndConditionsTickBox2Text, termsAndConditionsModalAgree, termsAndConditionsModalDisagree, termsAndConditionsModalText }) => {
				if (
					termsAndConditionsModal instanceof HTMLElement &&
					termsAndConditionsTickBox1 instanceof HTMLInputElement &&
					termsAndConditionsTickBox1Text instanceof HTMLLabelElement &&
					termsAndConditionsTickBox2 instanceof HTMLInputElement &&
					termsAndConditionsTickBox2Text instanceof HTMLLabelElement &&
					termsAndConditionsModalAgree instanceof HTMLElement &&
					termsAndConditionsModalDisagree instanceof HTMLElement &&
					termsAndConditionsModalText instanceof HTMLElement
				) {
					RenderingService.hideObject(termsAndConditionsModal);

					if (this._isPredefinedJourney) {
						RenderingService.showObject(termsAndConditionsModal);
						TermsAndConditionsStep.getTermsAndConditionsTextFromUrl(termsAndConditionsModalText);
						RenderingService.hideObject(termsAndConditionsTickBox1);
						RenderingService.hideObject(termsAndConditionsTickBox1Text);
						RenderingService.hideObject(termsAndConditionsTickBox2);
						RenderingService.hideObject(termsAndConditionsTickBox2Text);
					}
					else {
						TermsAndConditionsStep.getTermsAndConditionsConfigsFromBackend(this, termsAndConditionsModal, termsAndConditionsModalText, termsAndConditionsTickBox1, termsAndConditionsTickBox1Text, termsAndConditionsTickBox2, termsAndConditionsTickBox2Text);
					}

					termsAndConditionsModalAgree.addEventListener('click', () => {
						if (this._isPredefinedJourney || (termsAndConditionsTickBox1.checked && termsAndConditionsTickBox2.checked)) {
							RenderingService.hideObject(termsAndConditionsModal);
							this._isTCCAccepted = true;
							this.evaluate(false, this._isPredefinedJourney);
						}
					});

					termsAndConditionsModalDisagree.addEventListener('click', () => {
						RenderingService.hideObject(termsAndConditionsModal);
						this._journey!.cancel(HighLevelResult.TCCDisagree);
						this.evaluate();
					});
				} else {
					throw ExceptionManager.process(new ExceptionManager.TemplateException(TranslationKey.EXCEPTION_TEMPLATE_ELEMENTS_MISSING));
				}
			})
			.then(() => EventService.publish(JourneyEvent.DISPLAY_STEP, { step: Templates.TermsAndConditions }));
	}

	private static getTermsAndConditionsTextFromUrl(termsAndConditionsModalText: HTMLElement): any {
		const config = {
			headers: {
				"Accept": "text/html"
			}
		};
		HttpService.get("https://www.gbgplc.com/gbgidentifyappprivacypolicy.html", config).then((htmlResponse) => {
			termsAndConditionsModalText.innerHTML = htmlResponse;
		})
	}

	private static getTermsAndConditionsConfigsFromBackend(journeyContainer: any, termsAndConditionsModal: HTMLElement, termsAndConditionsModalText: HTMLElement, termsAndConditionsTickBox1: HTMLInputElement, termsAndConditionsTickBox1Text: HTMLElement, termsAndConditionsTickBox2: HTMLInputElement, termsAndConditionsTickBox2Text: HTMLElement): any {
		HttpService.get(ENDPOINTS.getTCCConfigs).then((result) => {
			if (result.ConsentCaptureEnabled === false) {
				RenderingService.hideObject(termsAndConditionsModal);
				journeyContainer._isTCCAccepted = true;
				journeyContainer.evaluate(undefined, false, true);
			}
			else
				RenderingService.showObject(termsAndConditionsModal);

			if (result.TCCTickBox1Enabled === false) {
				termsAndConditionsTickBox1.checked = true;
				RenderingService.hideObject(termsAndConditionsTickBox1);
				RenderingService.hideObject(termsAndConditionsTickBox1Text);
			}

			if (result.TCCTickBox2Enabled === false) {
				termsAndConditionsTickBox2.checked = true;
				RenderingService.hideObject(termsAndConditionsTickBox2);
				RenderingService.hideObject(termsAndConditionsTickBox2Text);
			}

			termsAndConditionsModalText.innerHTML = result.TCCText;
			termsAndConditionsTickBox1Text.innerHTML = result.TCCTickBox1Text;
			termsAndConditionsTickBox2Text.innerHTML = result.TCCTickBox2Text;
		})
	}
}
